import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Filters from '../../components/Filters';
import MultiSelectField from '../../components/form/MultiSelectField';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;
    const [ serviceCenters, setServiceCenters ] = useState(null);
    const [ selectedServiceCenter, setSelectedServiceCenter ] = useState(null);

    const [serviceCenterApi] = getApi('serviceCenters');

    useEffect(() => {
      fetchApiData(serviceCenterApi, "service_centers", { fields: 'options', filters: { rental: true } }, setServiceCenters);
    }, [])


    useEffect(()=>{
      if (serviceCenters && filtersModel) {
        let s = new Set(filtersModel.service_center_ids)
        setSelectedServiceCenter(serviceCenters.filter(service_center => s.has(service_center.id)))
      }
    }, [filtersModel])

    const fetchApiData = async (api, key, params = {}, setFunction) => {
      try {
        let response = await api(params).unwrap();
        setFunction(response.data[key]);
      } catch (error) {
        toast.error(error.data.message || "Something Went Wrong !");
      }
    }
    const onMultiSelectSelect = (key, selectedItem, array_key = false) => {
      setFiltersModel((prevState) => {
        if( array_key ) {
          if(prevState && Object.keys(prevState).includes(key)) return {...prevState, [key]: [...(prevState[key] || []), selectedItem.id] }
          return {...prevState, [key]: [selectedItem.id] }
        }
        return {...prevState, [key]: selectedItem.id }
      })
    }

    const onMultiSelectRemove = (key, removedItem, array_key = false) => {
      setFiltersModel((prevState) => {
        if( array_key ) {
          return {...prevState, [key]: prevState[key].filter((id)=> id !== removedItem.id) }
        } 
        return {...prevState, [key]: "" }
      })
    }


    const onBikeSelect = (selectedList, selectedItem) => {
      setFiltersModel((prevState)=> {
        return {...prevState, bike_ids: [...(prevState?.bike_ids || []), selectedItem.id ]}
      })
    }
 
    const onBikeRemove = (selectedList, selectedItem) => {
      setFiltersModel((prevState)=> {
        return {...prevState, bike_ids: prevState['bike_ids'].filter((bike_id) => selectedItem.id != bike_id)}
      })
    }

    const availiabilityTypeClick = (e) => {
      e.preventDefault();
      if (e.target.value === 'select_one' ) return;
      setFiltersModel((prevState)=>{
        return { ...prevState, availiability_type: e.target.value}
      })
    }
    const availiabilityUsageType = (e) => {
      e.preventDefault();
      if (e.target.value === 'select_one' ) return;
      setFiltersModel((prevState)=>{
        return { ...prevState, usage_type: e.target.value}
      })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
      <div>
          <Form.Group className="mb-3">
              <Form.Label>Select Availiability Type</Form.Label>
                <select onChange={availiabilityUsageType} id="action" defaultValue={filtersModel?.usage_type ? filtersModel.usage_type : ""} className='form-control form-control-sm font-size-11'>
                  <option value="" disabled>Select Action</option>
                  <option value="lease">Lease </option>
                  <option value="rent">Rent</option>
                </select>
          </Form.Group>
          <Form.Group className="mb-3">
              <Form.Label>Select Bikes</Form.Label>
              <MultiSelectField
                options={[]}
                fieldName="bike_ids"
                stateModel={filtersModel}
                dynamicOptions={{
                  dependsOnFields: [],
                  apiName: "bikes",
                  dataAttr: "bikes",
                }}
                labelAttr="name"
                valueAttr="id"
                displayValue="name"
                onSelect={onBikeSelect}
                onRemove={onBikeRemove}
                showCheckbox={true}
              />
          </Form.Group>
          <Form.Group className="mb-3">
              <Form.Label>Select Hub</Form.Label>
               <Multiselect
                id='service_type_id'
                selectedValues={selectedServiceCenter}
                options={serviceCenters}
                onSelect={(selectedList, selectedItem) => onMultiSelectSelect("service_center_ids", selectedItem, true)}
                onRemove={(selectedList, removedItem) => onMultiSelectRemove("service_center_ids", removedItem, true)}
                placeholder='Select Service Center'
                displayValue='name'
                showArrow={true}
                customArrow={true}
                avoidHighlightFirstOption={true}
              />

              {/*<MultiSelectField
                options={[]}
                fieldName="service_center_ids"
                stateModel={filtersModel}
                dynamicOptions={{
                  dependsOnFields: [],
                  apiName: "serviceCenters",
                  dataAttr: "service_centers",
                }}
                labelAttr="name"
                valueAttr="id"
                displayValue="name"
                onSelect={(selectedList, selectedItem) => onMultiSelectSelect("service_center_ids", selectedItem, true)}
                onRemove={(selectedList, removedItem) => onMultiSelectRemove("service_center_ids", removedItem, true)}
                showCheckbox={true}
              />*/}
          </Form.Group>
          {(filtersModel?.service_center_ids?.length !== undefined && filtersModel?.service_center_ids?.length !== 0 ) && 
          <Form.Group className="mb-3">
            <Form.Label>Select Availiability Type</Form.Label>
              <select onChange={availiabilityTypeClick} id="action" defaultValue={filtersModel?.availiability_type ? filtersModel.availiability_type : "select_one"} className='form-control form-control-sm font-size-11'>
                <option value="select_one" disabled>Select Action</option>
                <option value="capitalization">Available for Capitalization</option>
                <option value="rent">Available for Pickup</option>
              </select>
          </Form.Group>}         
      </div>
    </Filters>
};

export default FiltersPartial;
